import { VOUCHER_APPROVAL, VOUCHER_APPROVAL_SUCCESS, VOUCHER_APPROVAL_ERROR, VOUCHER_APPROVAL_EMPTY } from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const VoucherApproval = (state = initialState, action) => {
  switch (action.type) {
    case VOUCHER_APPROVAL:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case VOUCHER_APPROVAL_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case VOUCHER_APPROVAL_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case VOUCHER_APPROVAL_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default VoucherApproval;
